import { render, staticRenderFns } from "./MostLikesTitleBrief.vue?vue&type=template&id=0a9b57ec&scoped=true&"
import script from "./MostLikesTitleBrief.vue?vue&type=script&lang=js&"
export * from "./MostLikesTitleBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9b57ec",
  null
  
)

export default component.exports